import React from 'react';
import { withRouter } from 'react-router-dom';

class VisualizarUsuario extends React.Component {

    constructor() {

        super();

        this.state = {
            id: 0,
            nome: "",
            email: "",
            login: "",
            senha: "",
            salt: 0,
            role: "",
            ativo: "",
            restritoCentro: "",
            centroId: 0,
            centro: "",
            permissaoUsuarios: "",
            permissaoCentros: "",
            permissaoEstoque: "",
            permissaoContas: "",
            permissaoMovimentacoes: "",
            permissaoRelatorios: ""
        };

        this.editar = this.editar.bind(this);
        this.voltar = this.voltar.bind(this);

    }

    estaAtivo(ativo) {
        if (ativo)  return "Ativo";
        else return "Inativo";
    }

    estaRestrito(restrito) {
        if (restrito) return "Sim";
        else return "Não";
    }

    editar() {

        let obj = {
            id: this.state.id,
            nome: this.state.nome,
            email: this.state.email,
            login: this.state.login,
            senha: this.state.senha,
            salt: this.state.salt,
            role: this.state.role,
            ativo: this.state.ativo,
            restritoCentro: this.state.restritoCentro,
            centroId: this.state.centroId,
            centro: this.state.centro,
            permissaoUsuarios: this.state.permissaoUsuarios,
            permissaoCentros: this.state.permissaoCentros,
            permissaoEstoque: this.state.permissaoEstoque,
            permissaoContas: this.state.permissaoContas,
            permissaoMovimentacoes: this.state.permissaoMovimentacoes,
            permissaoRelatorios: this.state.permissaoRelatorios
        };

        this.props.history.push({
            pathname: "/editarusuario",
            state: obj
        });

    }

    voltar() {
        this.props.history.push("/usuarios");
    }

    componentDidMount() {

        if (localStorage.roleUsuarios === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/usuarios";
        }

        let usuarioId = this.props.location.state.row.id;
        this.setState({ id: usuarioId });

        fetch("/api/usuario/" + usuarioId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ nome: responseJson.nome });
            this.setState({ email: responseJson.email });
            this.setState({ login: responseJson.login });
            this.setState({ senha: responseJson.senha });
            this.setState({ salt: responseJson.salt });
            this.setState({ senha: responseJson.senha });
            this.setState({ role: responseJson.role });
            this.setState({ ativo: responseJson.ativo });
            this.setState({ restritoCentro: responseJson.restrito_centro });
            this.setState({ centroId: responseJson.centro_id });
            this.setState({ centro: responseJson.centro });

            let role = this.state.role.split(";");
            this.setState({ permissaoUsuarios: role[0].split("=")[1] });
            this.setState({ permissaoCentros: role[1].split("=")[1] });
            this.setState({ permissaoEstoque: role[2].split("=")[1] });
            this.setState({ permissaoContas: role[3].split("=")[1] });
            this.setState({ permissaoMovimentacoes: role[4].split("=")[1] });
            this.setState({ permissaoRelatorios: role[5].split("=")[1] });

        });

    }

    render() {
        return (
            <div>
                <h1 id="visualizar-usuario-titulo">Usuário</h1><br /><br />
                <table id="visualizar-usuario-table">
                    <tbody>
                        <tr>
                            <td><b>Nome:</b></td>
                            <td>{ this.state.nome }</td>
                        </tr>
                        <tr>
                            <td><b>E-mail:</b></td>
                            <td>{ this.state.email }</td>
                        </tr>
                        <tr>
                            <td><b>Centro:</b></td>
                            <td>{ this.state.centro }</td>
                        </tr>
                        <tr>
                            <td><b>Status:</b></td>
                            <td>{ this.estaAtivo(this.state.ativo) }</td>
                        </tr>
                        <tr>
                            <td><b>Usuário restrito ao Centro: </b></td>
                            <td>{ this.estaRestrito(this.state.restritoCentro) }</td>
                        </tr>
                        <tr>
                            <td colspan={ 2 }><center><b>Permissões</b></center></td>
                        </tr>
                        <tr>
                            <td><b>Usuários:</b></td>
                            <td>{ this.state.permissaoUsuarios }</td>
                        </tr>
                        <tr>
                            <td><b>Centros:</b></td>
                            <td>{ this.state.permissaoCentros }</td>
                        </tr>
                        <tr>
                            <td><b>Estoque:</b></td>
                            <td>{ this.state.permissaoEstoque }</td>
                        </tr>
                        <tr>
                            <td><b>Contas:</b></td>
                            <td>{ this.state.permissaoContas }</td>
                        </tr>
                        <tr>
                            <td><b>Movimentações:</b></td>
                            <td>{ this.state.permissaoMovimentacoes }</td>
                        </tr>
                        <tr>
                            <td><b>Relatórios:</b></td>
                            <td>{ this.state.permissaoRelatorios }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                { localStorage.roleUsuarios === "escrever" &&
                    <button id="visualizar-usuario-btn" onClick={ this.editar }>
                        Editar
                    </button> }
                <button id="visualizar-usuario-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarUsuario);

